module.exports = __webpack_public_path__ + "img/55.0d40b5ad.svg";